import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAtom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAtom"><Path d="M19.941 4.059C21.6117 5.72974 19.4108 10.6395 15.0251 15.0251C10.6395 19.4108 5.72974 21.6117 4.059 19.941C2.38826 18.2703 4.58917 13.3606 8.97486 8.97486C13.3606 4.58917 18.2703 2.38826 19.941 4.059Z" stroke="currentColor"/><Path d="M19.941 19.941C18.2703 21.6117 13.3605 19.4108 8.97486 15.0251C4.58916 10.6394 2.38826 5.72974 4.059 4.059C5.72974 2.38826 10.6394 4.58916 15.0251 8.97486C19.4108 13.3605 21.6117 18.2703 19.941 19.941Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAtom;
